module.exports = __webpack_public_path__ + "img/reno.077630fb.png";